import React, { useState } from "react";
import { images } from "../../../utils/customFn";
import { NavLink } from "react-router-dom";
import { Sidebar } from "react-pro-sidebar";
import "./sidebar.scss";
import UseSidebar from "./sidebarUtils";
import MenuItems from "../menuitems";
import { useClickAway } from "@uidotdev/usehooks";
import { useEffect } from "react";

const SidebarDashboard = () => {
  const { IsCollapsed, setIsCollapsed } = UseSidebar();
  const [ checkSide, setCheckSide ] = useState(true);
  
  return (
    <div className="sidebar_profile admin-sidebar-main">
      <div style={{ display: "flex", height: "100vh" }}>
        <Sidebar collapsed={IsCollapsed} className="info-sidebar">
          <div className="sidebar_logo">
            <NavLink to="/main-dashboard">


                <div className="page_logo_main">
                 <img src={images['side_logo.png']} alt="" />
                </div> 
            </NavLink>
          </div>
          <MenuItems collapsed={IsCollapsed} checkSide={checkSide} setCheckSide={setCheckSide}  />
        </Sidebar>
  
      </div>
    </div>
  );
};

export default SidebarDashboard;
